import React from "react";

import { Route, Switch } from "react-router-dom";

import { BuildingEdit } from "./BuildingEdit";
import {
  CREATE_BLOCKS,
  CREATE_BUILDING,
  CREATE_INSTALATION,
  EDIT_BUILDING,
  EDIT_INSTALATION,
} from "routers/routePaths";
import { InstalationsCreate } from "./InstalationsCreate";
import { BlocksPavementsCreate } from "./BlocksPavementsCreate";
import { InstalationsEdit } from "./InstalationsEdit";
import { BuildingCreate } from "./BuildingCreate";

export const BuildingsRouter = () => {
  return (
    <Switch>
      <Route exact path={EDIT_BUILDING} component={BuildingEdit} />
      <Route exact path={CREATE_BUILDING} component={BuildingCreate} />
      <Route exact path={CREATE_INSTALATION} component={InstalationsCreate} />
      <Route exact path={EDIT_INSTALATION} component={InstalationsEdit} />
      <Route exact path={CREATE_BLOCKS} component={BlocksPavementsCreate} />
    </Switch>
  );
};
